import React from 'react';
import { Mail } from 'lucide-react';
import { CHECKOUT_MESSAGES } from '../../constants/checkout';
import { UserType } from '../../types/plan';

interface CheckoutPostPaymentNoticeProps {
  userType: UserType;
}

/** Aviso pós-pagamento no checkout — mensagem conforme tipo do plano (constelador ou participante). */
const CheckoutPostPaymentNotice: React.FC<CheckoutPostPaymentNoticeProps> = ({ userType }) => {
  const notice =
    userType === UserType.THERAPIST
      ? CHECKOUT_MESSAGES.postPaymentNoticeTherapist
      : CHECKOUT_MESSAGES.postPaymentNoticeParticipant;

  return (
    <div
      className="flex w-full min-w-0 items-start gap-3 rounded-xl border border-[#C5E8E0] bg-[#EAF4F2] px-4 py-3.5 sm:px-5 sm:py-4"
      role="note"
      aria-label={notice.ariaLabel}
    >
      <Mail className="mt-0.5 h-5 w-5 shrink-0 text-[#4A7C75]" aria-hidden />
      <p className="min-w-0 text-sm leading-relaxed text-[#2D5A54] sm:text-base">{notice.message}</p>
    </div>
  );
};

export default CheckoutPostPaymentNotice;
